require('jquery-mousewheel');
require(
  'imports-loader?jQuery=jquery!' +
  './jquery.mcustomscrollbar.js'
);
